import React, { Fragment } from 'react';
import { AppState } from 'core/redux/reducers';
import { selectActiveProductMenuCoursesInfo } from 'core/redux/features/products/reducers/productInfos';
import { useSelector } from 'react-redux';

export default function MenuCourses({ menuId }: { menuId: number }) {
  const courses = useSelector((state: AppState) =>
    selectActiveProductMenuCoursesInfo(state, menuId),
  );

  return (
    <Fragment>
      {courses &&
        courses.map((course, index) => {
          const num = index + 1;
          return (
            <Fragment key={index}>
              <p className="label">{course.title}</p>
              <p>{course.description}</p>
              {courses.length !== num ? <hr /> : null}
            </Fragment>
          );
        })}
    </Fragment>
  );
}
